export default "__VITE_ASSET__S4gb$gnH__"